<template lang="pug">
main.modal-wrapper
    svg-icon.close-modal.cursor(name='close' size="small" @click.native="closeModal")

    main.modal-main
        header.modal-header
            sectionHeader(title="Volume Alert")
            div.subheader
                div.subheader-info Set volume alert to receive an email when daily volume reach a limit.

        div.modal-content
            FormVolumeAlert(parent="monitoring")

</template>

<script>
//components
import FormVolumeAlert from '@/components/common/FormVolumeAlert'
import SectionHeader from '@/components/common/SectionHeader'

//avoid repeating namespace for each store action/mutation/getter/state
import { mapMutations, mapState } from 'vuex'

export default {
    name: 'MonitoringFormVolumeAlert',
    components: { FormVolumeAlert, SectionHeader },

    data() {
        return {}
    },

    computed: {
        // Call to state
        ...mapState('account', {
            accountId: state => state.accountId
        })
    },

    methods: {
        ...mapMutations('ui/volumeAlert', ['setDefaultVolumeAlertForm']),

        closeModal() {
            this.setDefaultVolumeAlertForm()
        }
    }
}
</script>
